module.exports = __webpack_public_path__ + "static/media/ic_general_energy_black.56a5ba8b.svg";